<template>
  <div class="container_j">
    <nav class="nav_box">
      <a v-if="1" class="logo" href="#">
        <img src="../images/logo.png" />
      </a>
      <div v-if="1" class="search_box input-group">
        <input
          type="text"
          class="cosa"
          placeholder="Cosa cerchi?"
          aria-label="Cosa cerchi?"
          aria-describedby="basic-addon2"
        />
        <div class="input-group-append">
          <button class="btn btn-outline-secondary trova" type="button">
            <i class="fas fa-search"></i>
          </button>
        </div>
        <qrCodeScanner></qrCodeScanner>
      </div>
      <div class="btn-group">
        <a
          class="cerchio_user"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >{{loginStates.userProfile.cognome +' '+loginStates.userProfile.nome | iniziali}}</a>
        <div class="dropdown-menu">
          <a class="dropdown-item" href="#">Impostazioni</a>
          <div class="dropdown-divider"></div>
          <a class="dropdown-item" @click="logOut" href="#">LogOut</a>
        </div>
      </div>
    </nav>
    <!--<filtri class="filters"></filtri>-->
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  name: "Navbar",
  computed: {
    ...mapState(["loginStates"]),
    ...mapActions({
      getUserDettails: "loginStates/getUserProfile" // map `this.add()` to `this.$store.dispatch('increment')`
    })
  },
  methods: {
    logOut() {
      this.$store
        .dispatch("loginStates/logOut")
        .then(user => {
          console.log(user);
        })
        .catch(err => {
          console.log(err);
        });
    }
  },
  mounted() {
    var self = this;
    this.getUserDettails.then(function(result) {
      self.$store.commit("loginStates/setUserProfile", result);
    });
  },
  data() {
    return {
      // PLACEHOLDER
    };
  },
  filters: {
    iniziali: function(value) {
      return value ? value.match(/\b\w/g).join("") : "N D";
    }
  }
};
</script>
<style scoped>
.container_j {
  display: relative;
  padding-left: 1vw;
}

.nav_box {
  display: flex;
  height: 1vh;
  padding-top: 2vh;
}

.filters {
  margin-top: 8.5vh;
  outline: 0 !important;
}

.logo {
  /*PLACEHOLDER*/
}

.search_box {
  margin-left: 20px;
  /*PLACEHOLDER*/
}

.navbar_menu {
  /*PLACEHOLDER*/
  list-style-type: none;
}

.cerchio_user {
  background-color: grey !important;
  color: white !important;
  border-radius: 50%;
  height: 5.7vh !important;
  width: 5.7vh !important;
  line-height: 5.7vh;
  text-align: center;
  font-weight: bold;
  font-size: 2.5vh;
  margin-right: 2vw;
}

.cosa {
  border: none;
  color: white;
  outline: none !important;
  padding-left: 2.1vh;
  font-size: 2vh;
  -webkit-border-top-left-radius: 20px;
  -webkit-border-bottom-left-radius: 20px;
  -moz-border-radius-topleft: 20px;
  -moz-border-radius-bottomleft: 20px;
  border-top-left-radius: 20px;
  border-bottom-left-radius: 20px;
  background-color: rgb(4, 132, 196) !important;
}

.cosa:focus {
  outline: none !important;
}

::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #92c1f2;
  opacity: 1; /* Firefox */
}

:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #92c1f2;
}

::-ms-input-placeholder {
  /* Microsoft Edge */
  color: #92c1f2;
}

.trova {
  background-color: rgb(4, 132, 196) !important;
  color: #bcddff;
  border: none;
  -webkit-border-top-right-radius: 20px !important;
  -webkit-border-bottom-right-radius: 20px !important;
  -moz-border-radius-topright: 20px !important;
  -moz-border-radius-bottomright: 20px !important;
  border-top-right-radius: 20px !important;
  border-bottom-right-radius: 20px !important;
}

.cosa::-webkit-input-placeholder {
  /* Chrome/Opera/Safari */
  font-weight: 500;
}
.cosa::-moz-placeholder {
  /* Firefox 19+ */
  font-weight: 500;
}
.cosa:-ms-input-placeholder {
  /* IE 10+ */
  font-weight: 500;
}
.cosa:-moz-placeholder {
  /* Firefox 18- */
  font-weight: 500;
}

.totale_merce {
  position: absolute;
  right: 30px;
  font-size: 14px;
  color: white;
}

.filters {
}
</style>